import { SidebarCompanySelectController } from './sidebar-company-select-directive.controller'

function sidebarCompanySelect () {
  return {
    restrict: 'E',
    scope: {
      showDropdown: '=',
      expanded: '=',
      mobile: '<'
    },
    templateUrl: '/core/directives/sidebar-company-select/sidebar-company-select-directive.html?$$REVISION$$',
    controller: SidebarCompanySelectController
  }
}
export { sidebarCompanySelect }
